import { Checkbox, ListItemText } from '@mui/material';
import React from 'react';

import { IDepartment } from '../../../../../types/organizations';
import { checkboxStyles, StyledMenuItem } from './DepartmentFilter.styles';

interface IDepartmentMenuItemProps {
  department: IDepartment;
  index: number;
  isSelected: boolean;
  isFocused: boolean;
  onItemClick: (departmentUid: string, isSelected: boolean) => (e: React.MouseEvent) => void;
  onKeyDown: (event: React.KeyboardEvent) => void;
  onRef: (index: number, el: HTMLLIElement | null) => void;
}

export const DepartmentMenuItem: React.FC<IDepartmentMenuItemProps> = ({
  department,
  index,
  isSelected,
  isFocused,
  onItemClick,
  onKeyDown,
  onRef,
}) => (
  <StyledMenuItem
    key={department.uid}
    value={department.uid}
    selected={isSelected}
    disableRipple
    ref={(el) => onRef(index, el)}
    onClick={onItemClick(department.uid, isSelected)}
    onKeyDown={onKeyDown}
    tabIndex={isFocused ? 0 : -1}
    data-action={`department_filter_option_${department.uid}`}
  >
    <Checkbox sx={checkboxStyles} checked={isSelected} />
    <ListItemText primary={department.name} />
  </StyledMenuItem>
);
